import React from 'react';
import SIcon from './SIcon';
import { faSignalWeak } from '@fortawesome/pro-duotone-svg-icons';

const Icon = props => <SIcon {...props} icon={faSignalWeak} fa />;

export default Icon;
